import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {addMinute, checkTimeBefore} from 'js/Core/date';
import Calendar from '../Components/Calendar';
import TimeLine from '../Components/TimeLine';
import { setAppointmentField } from 'jsTheme/Actions/Appointments.action';
import { getSchedulers, setTimeLineField} from '../Actions/TimeLine.action';
import {roundTimeLine, roundDuration} from '../Core/utils';
import {customAddDate, customFormatDate, comparingDate, customDiffDate, customSubDate} from '../Core/date';
const mapStateToProps = state => {    
    return {
        steps: state.steps,
        timeBlockShop: state.shop.timeBlock,
        firstDateWorking: state.shop.firstDateWorking,
        toDateShop: state.shop.toDate,
        minTime: state.timelines.minTime,
        maxTime: state.timelines.maxTime,
        listTimeLine: state.timelines.listTimeLine,
        selectedCalendarTL: state.timelines.selectedCalendar,
        products: state.products
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setAppointmentField: (list) => dispatch(setAppointmentField(list)),
        getSchedulers: ()=>dispatch(getSchedulers()),
        setTimeLineField: (list) => dispatch(setTimeLineField(list))
    }
}

class CalendarContainer extends Component {
	constructor(props) {
        super(props);        
        ['navigateAction'].forEach(fn => this[fn] = this[fn].bind(this));        
    }
    componentDidMount(){
        const {getSchedulers, steps, timeBlockShop} = this.props;        
        let store = localStorage.getItem('idProduct') ? JSON.parse(localStorage.getItem('idProduct')) : '';        
        if(store !== '') {
            const {setAppointmentField, products, setTimeLineField} = this.props;
            const selectedProducts = products.filter(product=>store.indexOf(product.id)>=0);
            
            let duration = selectedProducts[0] ? selectedProducts[0].duration : 5;            

            if(selectedProducts[0]){
                setAppointmentField && setAppointmentField([{key: 'selectedProducts', value: store}]);
            }else{
                localStorage.removeItem('idProduct');
            }           
            setTimeLineField([{key: 'serviceDuration', value: roundDuration(duration, timeBlockShop)}])
        }  
        if(typeof (steps) === 'undefined'){
            getSchedulers && getSchedulers();
        }                     
    }
    listBlockTimeLine(){        
        let {minTime, maxTime, timeBlockShop} = this.props;
        let startTime = roundTimeLine(minTime, timeBlockShop, true),
            endTime = roundTimeLine(maxTime, timeBlockShop, true),
            listTime = [],
            time = startTime;
        
        if(endTime !== ''){
            while(checkTimeBefore(time, endTime, true)){
                listTime.push(time);
                time = addMinute(time, timeBlockShop);
            }
        }
        return listTime;
    }

    navigateAction(bol){
        let currentDateSelected = this.props.selectedCalendarTL;
        let {getSchedulers, setTimeLineField} = this.props;
        currentDateSelected = bol ? customAddDate(currentDateSelected, 7) : customSubDate(currentDateSelected, 7)
        setTimeLineField([{key: 'selectedCalendar', value: customFormatDate(currentDateSelected)}]);
        getSchedulers();
    }
    componentWillMount(){
        let selectedCalendarFormat = new Date(this.props.selectedCalendarTL);
        let firstDateWorkingFormat = new Date(this.props.firstDateWorking);
        if(comparingDate(selectedCalendarFormat, firstDateWorkingFormat) && 
            customDiffDate(firstDateWorkingFormat, selectedCalendarFormat) >= 7){                 
            this.navigateAction(true , true);
        }        
    }
    shouldComponentUpdate(newProps){
        let {steps} = this.props;
        if(newProps.minTime === '' || newProps.maxTime === ''){
            return false
        }                
        if(steps){            
            let newCurrentStep = newProps.steps.currentStep;
            if(newCurrentStep !== 2){   
                return false;
            }
        }
        return true;
    }
    render() {
        const  listBlockTimeLine = this.listBlockTimeLine(),
            headerCalendarProps = {
                selectedCalendar: this.props.selectedCalendarTL,
                navigateAction: this.navigateAction,
                listTimeLine: this.props.listTimeLine,
                firstDateWorking: this.props.firstDateWorking,
                toDateShop: this.props.toDateShop
            },
            timelineProps = {
                validateComponent: this.props.validateComponent,
                selectedCalendarTL: this.props.selectedCalendarTL,
                listBlockTimeLine,
                listTimeLine: this.props.listTimeLine,
                setAppointmentField: this.props.setAppointmentField
            };
    	return (
            <div className="main-timeline">
                <div className="content-timeline">
                    <Calendar {...headerCalendarProps} />
                    <TimeLine {...timelineProps} />
                    <div className="border-first"></div>
                </div>
            </div>
		)
    }
}

export  default connect(mapStateToProps, mapDispatchToProps)(CalendarContainer);
